import _extends from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["loading", "children", "engine"];
var __jsx = React.createElement;
import * as React from 'react';
import styled, { css } from 'styled-components';
import * as ds from '@bob/design-system';
export function ResultList(_ref) {
  var loading = _ref.loading,
      children = _ref.children,
      _ref$engine = _ref.engine,
      result = _ref$engine.result,
      ready = _ref$engine.ready,
      ulProps = _objectWithoutProperties(_ref, _excluded);

  var isClient = typeof window !== 'undefined';

  if (result.page.length === 0) {
    return __jsx("p", null, "Pas de r\xE9sultats");
  }

  return __jsx(React.Fragment, null, (!isClient || result.status === 'request' || !ready) && __jsx(Grid, null, loading), (!isClient || result.status === 'success' && ready) && __jsx(Grid, _extends({}, ulProps, {
    hidden: !isClient
  }), result.page.map(function (item) {
    return children({
      item: item
    });
  })));
}
var Grid = styled.ul.withConfig({
  displayName: "ResultList__Grid",
  componentId: "sc-1nyokwx-0"
})(["display:flex;flex-wrap:wrap;grid-gap:7%;justify-content:center;width:100%;", " & > *{margin-bottom:30px;}@media screen and (", "){display:grid;grid-gap:30px;grid-template-columns:repeat(2,1fr);justify-items:initial;row-gap:30px;& > *{margin-bottom:0;}}@media screen and (min-width:1240px){grid-template-columns:repeat(3,1fr);}"], function (_ref2) {
  var hidden = _ref2.hidden;
  return hidden && css(["height:0px;overflow:hidden;position:fixed;top:0;visibility:hidden;z-index:-1;"]);
}, ds.breakpoint.LAPTOP);